<template>
  <transition name="slide-screen" mode="out-in">
    <Timer v-if="isTimerOpened" />
    <Dashboard v-else />
  </transition>
</template>

<script>
import Dashboard from "./components/Dashboard";
import Timer from "./components/Timer";
import store from "./store/index";

export default {
  name: "App",
  store,
  components: {
    Dashboard,
    Timer
  },
  computed: {
    isTimerOpened() {
      return store.state.isTimerOpened;
    }
  }
};
</script>

<style>
:root {
  --gray-1: 255, 255, 255;
  --gray-2: 249, 249, 250;
  --gray-3: 239, 240, 242;
  --gray-4: 219, 222, 225;
  --text-1: 33, 33, 33;
  --text-2: 177, 177, 177;
  --accent: 0, 123, 255;
  --gutter: 20px;
  --brs: calc(var(--gutter) / 4);
  --smooth-fast: 0.2s ease;
  --smooth-slow: 0.8s ease;
  --font: system-ui, sans-serif;
}

@media (prefers-color-scheme: dark) {
  :root {
    --gray-1: 17, 20, 24;
    --gray-2: 25, 31, 36;
    --gray-3: 35, 42, 49;
    --gray-4: 56, 67, 79;
    --text-1: 224, 224, 224;
  }
}

* {
  box-sizing: border-box;
}

::-webkit-scrollbar {
  display: none;
}

body {
  margin: 0;
  background: rgb(var(--gray-1));
  color: rgb(var(--text-1));
  font-family: var(--font);
  min-width: 320px;
  user-select: none;
  overflow-x: hidden;
  line-height: 1.2;
}

input,
button {
  outline: none;
  font-size: 16px;
}

button {
  cursor: pointer;
}

img {
  pointer-events: none;
}

.container {
  margin: 0 auto;
  width: 768px;
  max-width: 100%;
  padding: 0 var(--gutter);
}

.screen {
  width: 100%;
  height: 100vh;
}

.slide-screen-enter-active {
  transition: var(--smooth-fast);
}

.slide-screen-leave-active {
  transition: var(--smooth-slow);
}

.slide-screen-enter {
  opacity: 0;
  transform: translateY(var(--gutter)) scale(1.4);
}

.slide-screen-leave-to {
  opacity: 0;
}
</style>
